
// // public/src/pages/Services.jsx
// import React, { useState, useEffect } from "react";
// import { motion } from "framer-motion";
// import { Link } from "react-router-dom";
// import {
//   FiFilter,
//   FiSearch,
//   FiArrowRight,
//   FiStar,
//   FiClock,
//   FiCheckCircle,
// } from "react-icons/fi";
// import axios from "axios";

// function Services() {
//   const [services, setServices] = useState([]);
//   const [filteredServices, setFilteredServices] = useState([]);
//   const [categories, setCategories] = useState([]);
//   const [selectedCategory, setSelectedCategory] = useState("all");
//   const [searchTerm, setSearchTerm] = useState("");
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     fetchServices();
//   }, []);

//   useEffect(() => {
//     filterServices();
//   }, [services, selectedCategory, searchTerm]);

//   const fetchServices = async () => {
//     try {
//       const response = await axios.get(
//         "https://agri-back-mauve.vercel.app/api/content/public/service"
//       );
//       if (response.data.success) {
//         const servicesData = response.data.data;
//         setServices(servicesData);

//         const uniqueCategories = [
//           ...new Set(
//             servicesData
//               .map((service) => service.category)
//               .filter((category) => category)
//           ),
//         ];
//         setCategories(uniqueCategories);
//       }
//     } catch (error) {
//       console.error("Error fetching services:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const filterServices = () => {
//     let filtered = services;

//     if (selectedCategory !== "all") {
//       filtered = filtered.filter(
//         (service) => service.category === selectedCategory
//       );
//     }

//     if (searchTerm) {
//       filtered = filtered.filter(
//         (service) =>
//           service.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
//           service.description.toLowerCase().includes(searchTerm.toLowerCase())
//       );
//     }

//     setFilteredServices(filtered);
//   };

//   if (loading) {
//     return (
//       <div className="min-h-screen bg-gradient-to-b from-gray-50 to-green-50 flex items-center justify-center">
//         <div className="text-center">
//           <div className="w-16 h-16 border-4 border-green-500 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
//           <p className="text-green-700 font-semibold">Loading services...</p>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="services-page min-h-screen bg-gradient-to-b from-gray-50 to-green-50">
//       {/* Hero Section */}
//       <section className="page-hero bg-gradient-to-r from-green-900 to-emerald-800 text-white py-20">
//         <div className="container mx-auto px-4 sm:px-6 lg:px-8">
//           <motion.div
//             initial={{ opacity: 0, y: 30 }}
//             animate={{ opacity: 1, y: 0 }}
//             transition={{ duration: 0.7 }}
//             className="text-center max-w-4xl mx-auto"
//           >
//             <h1 className="text-5xl md:text-6xl font-bold mb-6 bg-gradient-to-r from-green-400 to-emerald-400 bg-clip-text text-transparent">
//               Our AgriTech Solutions
//             </h1>
//             <p className="text-xl md:text-2xl text-gray-200 leading-relaxed">
//               Comprehensive technology solutions designed for modern African
//               agriculture. Empowering farmers with cutting-edge innovations.
//             </p>
//           </motion.div>
//         </div>
//       </section>

//       {/* Filters Section */}
//       <section className="filters-section py-8 bg-white/80 backdrop-blur-sm border-b border-green-100 sticky top-0 z-10">
//         <div className="container mx-auto px-4 sm:px-6 lg:px-8">
//           <div className="filters-container flex flex-col lg:flex-row gap-6 items-center justify-between">
//             {/* Search Box */}
//             <div className="search-box relative w-full lg:w-96">
//               <div className="relative">
//                 <FiSearch className="absolute left-4 top-1/2 transform -translate-y-1/2 text-green-600 w-5 h-5" />
//                 <input
//                   type="text"
//                   placeholder="Search services..."
//                   value={searchTerm}
//                   onChange={(e) => setSearchTerm(e.target.value)}
//                   className="w-full pl-12 pr-6 py-4 bg-white border border-green-200 rounded-2xl focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all duration-300 text-gray-700 placeholder-green-400 shadow-sm hover:shadow-md"
//                 />
//               </div>
//             </div>

//             {/* Category Filters */}
//             <div className="category-filters flex flex-wrap gap-3 justify-center">
//               <motion.button
//                 whileHover={{ scale: 1.05 }}
//                 whileTap={{ scale: 0.95 }}
//                 className={`filter-btn px-6 py-3 rounded-2xl font-semibold transition-all duration-300 ${
//                   selectedCategory === "all"
//                     ? "bg-gradient-to-r from-green-500 to-emerald-500 text-white shadow-lg shadow-green-200"
//                     : "bg-white text-green-700 border border-green-200 hover:border-green-400 hover:shadow-md"
//                 }`}
//                 onClick={() => setSelectedCategory("all")}
//               >
//                 All Services
//               </motion.button>
//               {categories.map((category) => (
//                 <motion.button
//                   key={category}
//                   whileHover={{ scale: 1.05 }}
//                   whileTap={{ scale: 0.95 }}
//                   className={`filter-btn px-6 py-3 rounded-2xl font-semibold transition-all duration-300 ${
//                     selectedCategory === category
//                       ? "bg-gradient-to-r from-green-500 to-emerald-500 text-white shadow-lg shadow-green-200"
//                       : "bg-white text-green-700 border border-green-200 hover:border-green-400 hover:shadow-md"
//                   }`}
//                   onClick={() => setSelectedCategory(category)}
//                 >
//                   {category}
//                 </motion.button>
//               ))}
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Services Grid */}
//       <section className="services-grid-section py-16">
//         <div className="container mx-auto px-4 sm:px-6 lg:px-8">
//           {filteredServices.length === 0 ? (
//             <motion.div
//               initial={{ opacity: 0, scale: 0.9 }}
//               animate={{ opacity: 1, scale: 1 }}
//               className="no-results text-center py-16"
//             >
//               <div className="max-w-md mx-auto">
//                 <div className="w-24 h-24 mx-auto mb-6 bg-green-100 rounded-full flex items-center justify-center">
//                   <FiSearch className="w-12 h-12 text-green-600" />
//                 </div>
//                 <h3 className="text-2xl font-bold text-gray-700 mb-3">
//                   No services found
//                 </h3>
//                 <p className="text-gray-500 mb-6">
//                   Try adjusting your search or filters to find what you're
//                   looking for.
//                 </p>
//                 <button
//                   onClick={() => {
//                     setSearchTerm("");
//                     setSelectedCategory("all");
//                   }}
//                   className="px-6 py-3 bg-green-600 text-white rounded-2xl hover:bg-green-700 transition-colors duration-300 font-semibold"
//                 >
//                   Reset Filters
//                 </button>
//               </div>
//             </motion.div>
//           ) : (
//             <>
//               <motion.div
//                 initial={{ opacity: 0, y: 20 }}
//                 animate={{ opacity: 1, y: 0 }}
//                 className="results-info mb-8 text-center"
//               >
//                 <p className="text-green-700 font-semibold">
//                   Showing {filteredServices.length} service
//                   {filteredServices.length !== 1 ? "s" : ""}
//                   {selectedCategory !== "all" && ` in ${selectedCategory}`}
//                 </p>
//               </motion.div>

//               <div className="services-grid grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
//                 {filteredServices.map((service, index) => (
//                   <motion.div
//                     key={service._id}
//                     initial={{ opacity: 0, y: 30 }}
//                     animate={{ opacity: 1, y: 0 }}
//                     transition={{ delay: index * 0.1 }}
//                     whileHover={{ y: -8, scale: 1.02 }}
//                     className="service-card group bg-white rounded-3xl shadow-lg hover:shadow-2xl transition-all duration-500 overflow-hidden border border-green-100 flex flex-col h-full"
//                   >
//                     {/* Card Header */}
//                     <div className="p-6 pb-4">
//                       <div className="flex items-start justify-between mb-4">
//                         <div className="service-icon text-4xl">
//                           {service.icon === "precision" && "🌱"}
//                           {service.icon === "iot" && "📡"}
//                           {service.icon === "data" && "📊"}
//                           {service.icon === "drone" && "🚁"}
//                           {!service.icon && "🌾"}
//                         </div>
//                         <span className="service-category px-3 py-1 bg-green-100 text-green-700 rounded-full text-sm font-semibold">
//                           {service.category}
//                         </span>
//                       </div>

//                       <h3 className="text-xl font-bold text-gray-800 mb-3 group-hover:text-green-700 transition-colors duration-300">
//                         {service.title}
//                       </h3>

//                       <p className="text-gray-600 leading-relaxed line-clamp-3">
//                         {service.description}
//                       </p>
//                     </div>

//                     {/* Features Section */}
//                     {service.features && service.features.length > 0 && (
//                       <div className="service-features px-6 py-4 bg-green-50 border-y border-green-100">
//                         <div className="flex flex-wrap gap-2">
//                           {service.features.slice(0, 3).map((feature, i) => (
//                             <span
//                               key={i}
//                               className="feature-tag inline-flex items-center gap-1 px-3 py-1 bg-white text-green-700 rounded-full text-sm border border-green-200"
//                             >
//                               <FiCheckCircle className="w-3 h-3 text-green-500" />
//                               {feature}
//                             </span>
//                           ))}
//                           {service.features.length > 3 && (
//                             <span className="feature-tag px-3 py-1 bg-green-100 text-green-600 rounded-full text-sm">
//                               +{service.features.length - 3} more
//                             </span>
//                           )}
//                         </div>
//                       </div>
//                     )}

//                     {/* Card Footer */}
//                     <div className="service-footer p-6 pt-4 mt-auto">
//                       <div className="flex items-center justify-between">
//                         <div className="service-meta flex items-center gap-4 text-sm text-gray-500">
//                           <div className="flex items-center gap-1">
//                             <FiClock className="w-4 h-4" />
//                             <span>Quick setup</span>
//                           </div>
//                           <div className="flex items-center gap-1">
//                             <FiStar className="w-4 h-4" />
//                             <span>Expert support</span>
//                           </div>
//                         </div>

//                         <Link
//                           to={`/services/${service._id}`}
//                           className="service-link inline-flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-green-500 to-emerald-500 text-white rounded-2xl font-semibold hover:from-green-600 hover:to-emerald-600 transition-all duration-300 group-hover:shadow-lg"
//                         >
//                           Learn More
//                           <FiArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform duration-300" />
//                         </Link>
//                       </div>
//                     </div>
//                   </motion.div>
//                 ))}
//               </div>
//             </>
//           )}
//         </div>
//       </section>

//       {/* CTA Section */}
//       <section className="services-cta py-20 bg-gradient-to-r from-green-900 to-emerald-800">
//         <div className="container mx-auto px-4 sm:px-6 lg:px-8">
//           <motion.div
//             initial={{ opacity: 0, scale: 0.9 }}
//             whileInView={{ opacity: 1, scale: 1 }}
//             transition={{ duration: 0.7 }}
//             className="cta-content text-center max-w-4xl mx-auto"
//           >
//             <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
//               Ready to Transform Your Farm?
//             </h2>
//             <p className="text-xl text-green-200 mb-8 leading-relaxed">
//               Get a free consultation with our agricultural technology experts
//               and discover how our solutions can increase your productivity and
//               sustainability.
//             </p>
//             <div className="cta-buttons flex flex-col sm:flex-row gap-4 justify-center">
//               <Link
//                 to="/contact"
//                 className="cta-button primary inline-flex items-center justify-center px-8 py-4 bg-gradient-to-r from-green-500 to-emerald-500 text-white rounded-2xl font-bold text-lg hover:from-green-600 hover:to-emerald-600 transition-all duration-300 shadow-lg hover:shadow-xl"
//               >
//                 Get Consultation
//               </Link>
//               <Link
//                 to="/projects"
//                 className="cta-button secondary inline-flex items-center justify-center px-8 py-4 bg-white text-green-700 rounded-2xl font-bold text-lg hover:bg-green-50 transition-all duration-300 border border-transparent hover:border-green-200"
//               >
//                 View Our Projects
//               </Link>
//             </div>
//           </motion.div>
//         </div>
//       </section>
//     </div>
//   );
// }

// export default Services;


// public/src/pages/Services.jsx - UPDATED WITH DARK MODE SUPPORT
import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import {
  FiFilter,
  FiSearch,
  FiArrowRight,
  FiStar,
  FiClock,
  FiCheckCircle,
} from "react-icons/fi";
import axios from "axios";

function Services() {
  const [services, setServices] = useState([]);
  const [filteredServices, setFilteredServices] = useState([]);
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("all");
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchServices();
  }, []);

  useEffect(() => {
    filterServices();
  }, [services, selectedCategory, searchTerm]);

  const fetchServices = async () => {
    try {
      const response = await axios.get(
        "https://agri-back-mauve.vercel.app/api/content/public/service"
      );
      if (response.data.success) {
        const servicesData = response.data.data;
        setServices(servicesData);

        const uniqueCategories = [
          ...new Set(
            servicesData
              .map((service) => service.category)
              .filter((category) => category)
          ),
        ];
        setCategories(uniqueCategories);
      }
    } catch (error) {
      console.error("Error fetching services:", error);
    } finally {
      setLoading(false);
    }
  };

  const filterServices = () => {
    let filtered = services;

    if (selectedCategory !== "all") {
      filtered = filtered.filter(
        (service) => service.category === selectedCategory
      );
    }

    if (searchTerm) {
      filtered = filtered.filter(
        (service) =>
          service.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
          service.description.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }

    setFilteredServices(filtered);
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-b from-gray-50 to-green-50 dark:from-gray-900 dark:to-green-900 flex items-center justify-center">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-green-500 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-green-700 dark:text-green-300 font-semibold">Loading services...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="services-page min-h-screen bg-gradient-to-b from-gray-50 to-green-50 dark:from-gray-900 dark:to-green-900">
      {/* Hero Section */}
      <section className="page-hero bg-gradient-to-r from-green-900 to-emerald-800 text-white py-20">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7 }}
            className="text-center max-w-4xl mx-auto"
          >
            <h1 className="text-5xl md:text-6xl font-bold mb-6 bg-gradient-to-r from-green-400 to-emerald-400 bg-clip-text text-transparent">
              Our Services
            </h1>
            <p className="text-xl md:text-2xl text-gray-200 leading-relaxed">
              Comprehensive agricultural consulting and advisory services designed 
              to transform African agriculture through innovation and expertise.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Filters Section */}
      <section className="filters-section py-8 bg-white/80 dark:bg-gray-800/80 backdrop-blur-sm border-b border-green-100 dark:border-green-800 sticky top-0 z-10">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="filters-container flex flex-col lg:flex-row gap-6 items-center justify-between">
            {/* Search Box */}
            <div className="search-box relative w-full lg:w-96">
              <div className="relative">
                <FiSearch className="absolute left-4 top-1/2 transform -translate-y-1/2 text-green-600 dark:text-green-400 w-5 h-5" />
                <input
                  type="text"
                  placeholder="Search services..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="w-full pl-12 pr-6 py-4 bg-white dark:bg-gray-700 border border-green-200 dark:border-green-600 rounded-2xl focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all duration-300 text-gray-700 dark:text-gray-200 placeholder-green-400 dark:placeholder-green-300 shadow-sm hover:shadow-md dark:shadow-gray-900"
                />
              </div>
            </div>

            {/* Category Filters */}
            <div className="category-filters flex flex-wrap gap-3 justify-center">
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className={`filter-btn px-6 py-3 rounded-2xl font-semibold transition-all duration-300 ${
                  selectedCategory === "all"
                    ? "bg-gradient-to-r from-green-500 to-emerald-500 text-white shadow-lg shadow-green-200 dark:shadow-green-900"
                    : "bg-white dark:bg-gray-700 text-green-700 dark:text-green-300 border border-green-200 dark:border-green-600 hover:border-green-400 dark:hover:border-green-400 hover:shadow-md"
                }`}
                onClick={() => setSelectedCategory("all")}
              >
                All Services
              </motion.button>
              {categories.map((category) => (
                <motion.button
                  key={category}
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  className={`filter-btn px-6 py-3 rounded-2xl font-semibold transition-all duration-300 ${
                    selectedCategory === category
                      ? "bg-gradient-to-r from-green-500 to-emerald-500 text-white shadow-lg shadow-green-200 dark:shadow-green-900"
                      : "bg-white dark:bg-gray-700 text-green-700 dark:text-green-300 border border-green-200 dark:border-green-600 hover:border-green-400 dark:hover:border-green-400 hover:shadow-md"
                  }`}
                  onClick={() => setSelectedCategory(category)}
                >
                  {category}
                </motion.button>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Services Grid */}
      <section className="services-grid-section py-16">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          {filteredServices.length === 0 ? (
            <motion.div
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              className="no-results text-center py-16"
            >
              <div className="max-w-md mx-auto">
                <div className="w-24 h-24 mx-auto mb-6 bg-green-100 dark:bg-green-800 rounded-full flex items-center justify-center">
                  <FiSearch className="w-12 h-12 text-green-600 dark:text-green-400" />
                </div>
                <h3 className="text-2xl font-bold text-gray-700 dark:text-gray-300 mb-3">
                  No services found
                </h3>
                <p className="text-gray-500 dark:text-gray-400 mb-6">
                  Try adjusting your search or filters to find what you're looking for.
                </p>
                <button
                  onClick={() => {
                    setSearchTerm("");
                    setSelectedCategory("all");
                  }}
                  className="px-6 py-3 bg-green-600 text-white rounded-2xl hover:bg-green-700 transition-colors duration-300 font-semibold"
                >
                  Reset Filters
                </button>
              </div>
            </motion.div>
          ) : (
            <>
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                className="results-info mb-8 text-center"
              >
                <p className="text-green-700 dark:text-green-300 font-semibold">
                  Showing {filteredServices.length} service
                  {filteredServices.length !== 1 ? "s" : ""}
                  {selectedCategory !== "all" && ` in ${selectedCategory}`}
                </p>
              </motion.div>

              <div className="services-grid grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                {filteredServices.map((service, index) => (
                  <motion.div
                    key={service._id}
                    initial={{ opacity: 0, y: 30 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: index * 0.1 }}
                    whileHover={{ y: -8, scale: 1.02 }}
                    className="service-card group bg-white dark:bg-gray-800 rounded-3xl shadow-lg hover:shadow-2xl dark:shadow-gray-900/50 transition-all duration-500 overflow-hidden border border-green-100 dark:border-green-800 flex flex-col h-full"
                  >
                    {/* Card Header */}
                    <div className="p-6 pb-4">
                      <div className="flex items-start justify-between mb-4">
                        <div className="service-icon text-4xl">
                          {service.service?.icon === "precision" && "🌱"}
                          {service.service?.icon === "iot" && "📡"}
                          {service.service?.icon === "data" && "📊"}
                          {service.service?.icon === "drone" && "🚁"}
                          {service.service?.icon === "monitoring" && "👁️"}
                          {service.service?.icon === "analysis" && "🔍"}
                          {service.service?.icon === "consulting" && "💼"}
                          {!service.service?.icon && "🌾"}
                        </div>
                        <span className="service-category px-3 py-1 bg-green-100 dark:bg-green-900 text-green-700 dark:text-green-300 rounded-full text-sm font-semibold">
                          {service.category}
                        </span>
                      </div>

                      <h3 className="text-xl font-bold text-gray-800 dark:text-white mb-3 group-hover:text-green-700 dark:group-hover:text-green-400 transition-colors duration-300">
                        {service.title}
                      </h3>

                      <p className="text-gray-600 dark:text-gray-300 leading-relaxed line-clamp-3">
                        {service.description}
                      </p>
                    </div>

                    {/* Features Section */}
                    {service.service?.features && service.service.features.length > 0 && (
                      <div className="service-features px-6 py-4 bg-green-50 dark:bg-green-900/30 border-y border-green-100 dark:border-green-800">
                        <div className="flex flex-wrap gap-2">
                          {service.service.features.slice(0, 3).map((feature, i) => (
                            <span
                              key={i}
                              className="feature-tag inline-flex items-center gap-1 px-3 py-1 bg-white dark:bg-gray-700 text-green-700 dark:text-green-300 rounded-full text-sm border border-green-200 dark:border-green-600"
                            >
                              <FiCheckCircle className="w-3 h-3 text-green-500 dark:text-green-400" />
                              {feature}
                            </span>
                          ))}
                          {service.service.features.length > 3 && (
                            <span className="feature-tag px-3 py-1 bg-green-100 dark:bg-green-800 text-green-600 dark:text-green-400 rounded-full text-sm">
                              +{service.service.features.length - 3} more
                            </span>
                          )}
                        </div>
                      </div>
                    )}

                    {/* Card Footer */}
                    <div className="service-footer p-6 pt-4 mt-auto">
                      <div className="flex items-center justify-between">
                        <div className="service-meta flex items-center gap-4 text-sm text-gray-500 dark:text-gray-400">
                          <div className="flex items-center gap-1">
                            <FiClock className="w-4 h-4" />
                            <span>{service.service?.duration || "Custom"}</span>
                          </div>
                          <div className="flex items-center gap-1">
                            <FiStar className="w-4 h-4" />
                            <span>Expert support</span>
                          </div>
                        </div>

                        <Link
                          to={`/services/${service._id}`}
                          className="service-link inline-flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-green-500 to-emerald-500 text-white rounded-2xl font-semibold hover:from-green-600 hover:to-emerald-600 transition-all duration-300 group-hover:shadow-lg"
                        >
                          Learn More
                          <FiArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform duration-300" />
                        </Link>
                      </div>
                    </div>
                  </motion.div>
                ))}
              </div>
            </>
          )}
        </div>
      </section>

      {/* CTA Section */}
      <section className="services-cta py-20 bg-gradient-to-r from-green-900 to-emerald-800">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.7 }}
            className="cta-content text-center max-w-4xl mx-auto"
          >
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
              Ready to Transform Your Agricultural Projects?
            </h2>
            <p className="text-xl text-green-200 mb-8 leading-relaxed">
              Get expert consultation with our agricultural specialists and discover 
              how our services can enhance your project success and impact.
            </p>
            <div className="cta-buttons flex flex-col sm:flex-row gap-4 justify-center">
              <Link
                to="/contact"
                className="cta-button primary inline-flex items-center justify-center px-8 py-4 bg-gradient-to-r from-green-500 to-emerald-500 text-white rounded-2xl font-bold text-lg hover:from-green-600 hover:to-emerald-600 transition-all duration-300 shadow-lg hover:shadow-xl"
              >
                Get Consultation
              </Link>
              <Link
                to="/projects"
                className="cta-button secondary inline-flex items-center justify-center px-8 py-4 bg-white text-green-700 rounded-2xl font-bold text-lg hover:bg-green-50 transition-all duration-300 border border-transparent hover:border-green-200"
              >
                View Our Projects
              </Link>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
}

export default Services;